import React, { ReactElement, useCallback } from "react";
import { getBridgeSdk, GlobalHeaderState, isToingFlow, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { format, isEmpty, useMountedRef } from "@swiggy-private/core-ui";

// constants
import { HELP_TEXT, ORDER_HELP_PAGE_URL, TOING_ORDER_HELP_PAGE_URL } from "@payment-client/constants/TextDict";

// helpers
import { isBusinessLinePayOnDelivery } from "@payment-client/helpers/Misc";

// types
import { WebNavigateRequestPayload } from "@swiggy-private/native-bridge";

// styles
import { StyledTextButton } from "./styles";

function HeaderHelpButton(): ReactElement | null {
    const orderIdFromHeader = GlobalHeaderState.getHeader(SwgyHeaderKeysList.orderid);
    // use isMounted so that "help" doesnt shown up on ssr
    const isMountedRef = useMountedRef();

    const goToHelp = useCallback(() => {
        if (orderIdFromHeader) {
            const helpPageUrl = isToingFlow() ? TOING_ORDER_HELP_PAGE_URL : ORDER_HELP_PAGE_URL;
            const deeplinkUrl = format(helpPageUrl, orderIdFromHeader);

            const data: WebNavigateRequestPayload = {
                callbackUrl: window.location.href,
                openAsExternal: true,
                openAsExternalWithBridgeSupport: true, // this is needed in IOS Only
                showBack: false,
                title: "Order Help",
                url: deeplinkUrl,
                showLoader: true,
            };

            getBridgeSdk()
                .webNavigate(data)
                .catch(() => void 0);
        }
    }, [orderIdFromHeader]);

    if (!isMountedRef.current || !isBusinessLinePayOnDelivery() || isEmpty(orderIdFromHeader)) {
        return null;
    }

    return (
        <StyledTextButton buttonSize="small" color="primary" textAlign="right" removePadding onClick={goToHelp}>
            {HELP_TEXT}
        </StyledTextButton>
    );
}

export default HeaderHelpButton;
